import React from "react";

const CPP_List = () => {
  return (
    <div>
      <h1>CPP_List Component</h1>
      <p>Content for CPP_List goes here...</p>
    </div>
  );
};

export default CPP_List;
